<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/tWuKGL/tc-custom/1.png?1685328099052?1709062253332" alt="This image is the cover for the book The Adventures of Bottom Wind Billy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Adventures of Bottom Wind Billy
      </h1>
      <p class="bookDescription body article font2">
        <p>Bottom Wind Billy creates laughter and trouble everywhere he goes. This fun book for all ages offers humour, learning and life lessons.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Richard Bimson
      </h2>
      
      <p class="authorDescription body article">Bottom Wind Billy was created when I was asked to make up a bed time story for my eldest daughter Annabelle who was then 6 years old. I wanted to make her laugh but also tell her a story that had a feel-good factor, a moral message and offer an element of learning.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?13aaf3e9